import type { CSSProperties } from 'react';

import { rem } from '@mantine/core';

const css = `
  .dl-dots{display:inline-flex;gap:${rem(7)};align-items:center;line-height:0}
  .dl-dot{border-radius:50%;animation:dl-pop 1.5s ease-in-out infinite}
  .dl-d2{animation-delay:.2s}
  .dl-d3{animation-delay:.4s}
  @keyframes dl-pop{0%,100%{transform:translateY(0) scale(1);opacity:.3}45%{transform:translateY(-8px) scale(1.3);opacity:1}}
`;

const SIZES = { sm: rem(5), md: rem(7), lg: rem(9) } as const;

export interface OreLoaderProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
  style?: CSSProperties;
}

// Atom - three-dot pulse indicator for buttons and inline text.
// Registered as Mantine's default Loader in src/theme/assay.ts, so every
// <Loader /> and <Button loading> renders this component.
//
// `color` defaults to var(--assay-ore). When Mantine forwards a foreground
// color (e.g. near-black inside a filled gold Button) pass it through so the
// dots remain visible against the host surface.
//
// Usage - standalone:
//   <OreLoader size="lg" />
//
// Usage - inside a Mantine Button:
//   <Button leftSection={<OreLoader size="sm" />}>Enrich</Button>
//
// Usage - inline with Text:
//   <Text>Loading contacts <OreLoader size="sm" /></Text>
export function OreLoader({
  size = 'md',
  color = 'var(--assay-ore)',
  className = '',
  style,
}: OreLoaderProps) {
  const dim = SIZES[size];
  const dotStyle: CSSProperties = { width: dim, height: dim, background: color };

  return (
    <span className={`dl-dots ${className}`.trim()} style={style}>
      <style>{css}</style>
      <span className="dl-dot" style={dotStyle} />
      <span className="dl-dot dl-d2" style={dotStyle} />
      <span className="dl-dot dl-d3" style={dotStyle} />
    </span>
  );
}
